export enum UserRoleEnum {
  MasterAdmin = 'Master Admin',
  ProjectAdmin = 'Project Admin',
  User = 'User',
}
